import { FunctionComponent, MouseEventHandler } from "react";
import { useTranslation } from "react-i18next";
import {
    Box,
    Flex,
    FlexProps,
    MantineColor,
    Stack,
    Text,
    useMantineTheme,
} from "@mantine/core";
import {
    IconCheck,
    TablerIconsProps,
} from "@tabler/icons-react";
import { ReviewState } from "src/graphql/generated/graphql";

interface ControlButtonProps extends FlexProps {
    icon: FunctionComponent<TablerIconsProps>;
    color: MantineColor;
    isActive: boolean;
    isDisabled?: boolean;
    label: string;
    activeLabel: string;
    onClick?: MouseEventHandler<HTMLDivElement>;
}

const ControlButton = ({
    icon: Icon,
    color,
    isActive,
    isDisabled,
    label,
    activeLabel,
    onClick,
    ...rest
}: ControlButtonProps) => {
    const theme = useMantineTheme();

    return (
        <Flex
            {...rest}
            display="inline-flex"
            direction="column"
            align="center"
        >
            <Box
                pos="relative"
                w="52px"
                h="52px"
                sx={{
                    cursor: isDisabled ?
                        "default" : "pointer",
                    borderRadius: "50%",
                    borderWidth: "1px",
                    borderStyle: "solid",
                    backgroundColor: isActive ?
                        theme.colors[color][6] : undefined,
                    borderColor: isActive ?
                        theme.colors[color][6] : theme.colors.gray[2],
                    color: isActive ?
                        theme.white : theme.colors.gray[7],
                    "&:hover": isDisabled ? {} : {
                        backgroundColor: isActive ?
                            theme.colors[color][6] : theme.colors[color][0],
                        borderColor: isActive ?
                            theme.colors[color][6] : theme.colors[color][1],
                        color: isActive ?
                            theme.white : theme.colors[color][7],
                    },
                }}
                onClick={isDisabled ? undefined : onClick}
            >
                <Box
                    pos="absolute"
                    top="50%"
                    left="50%"
                    style={{
                        transform: "translate(-50%,-40%)",
                    }}
                >
                    <Icon size="32px" />
                </Box>
            </Box>
            <Text
                ta="center"
                color="dimmed"
                weight={isActive ? 500 : undefined}
            >
                {isActive ? activeLabel : label}
            </Text>
        </Flex>
    );
};

export interface ControlsProps {
    reviewState: ReviewState;
    onApproveClick?();
}

export const Controls = ({
    reviewState,
    onApproveClick,
}: ControlsProps) => {
    const { t } = useTranslation(["common"]);

    return (
        <Stack align="center">
            {(reviewState === ReviewState.Submitted || reviewState === ReviewState.Approved || reviewState === ReviewState.Rejected) && (
                <ControlButton
                    mb="md"
                    color="green"
                    icon={IconCheck}
                    isActive={reviewState === ReviewState.Approved}
                    isDisabled={reviewState !== ReviewState.Submitted && reviewState !== ReviewState.Rejected}
                    label={t("review_approve")}
                    activeLabel={t("review_approved")}
                    onClick={onApproveClick}
                />
            )}
            {/* {(reviewState === ReviewState.submitted || reviewState === ReviewState.rejected) && (
                <ControlButton
                    mb="md"
                    color="yellow"
                    icon={IconX}
                    isActive={reviewState === ReviewState.rejected}
                    isDisabled={reviewState !== ReviewState.submitted}
                    label={t("review_reject")}
                    activeLabel={t("review_rejected")}
                    onClick={onRejectClick}
                />
            )}
            {(reviewState === ReviewState.submitted || reviewState === ReviewState.censured) && (
                <ControlButton
                    mb="md"
                    color="gray"
                    icon={IconEyeOff}
                    isActive={reviewState === ReviewState.censured}
                    isDisabled={reviewState !== ReviewState.submitted}
                    label={t("review_censure")}
                    activeLabel={t("review_censured")}
                    onClick={onCensureClick}
                />
            )} */}
            {/* <Divider
                orientation="horizontal"
                color="gray.2"
                miw="80px"
                my="sm"
            />
            <ControlButton
                mb="md"
                color="orange"
                icon={IconFlag3}
                isActive={isFlagged}
                label={t("review_flag")}
                activeLabel={t("review_flagged")}
                onClick={onFlagClick}
            />
            {!isAwaitingClientApproval && (
                <ControlButton
                    mb="md"
                    color="pink"
                    icon={IconBrandTelegram}
                    isActive={isAwaitingClientApproval}
                    isDisabled={isAwaitingClientApproval}
                    label={t("review_requestclientapproval")}
                    activeLabel={t("review_requestclientapproval")}
                    onClick={onRequestClientApproval}
                />
            )} */}
        </Stack>
    );
};
